document.addEventListener("DOMContentLoaded", () => {
    let leftBox = document.querySelector('.compare__leftBoxParameters');
    if (leftBox) {
        setHeightOfCompareProducts();
        window.addEventListener('resize', function () {
            setHeightOfCompareProducts();
        });
    }

    let storeCompareProductButtons = document.querySelectorAll('.store-compare');
    let destroyCompareProductButtons = document.querySelectorAll('.compare__removeItem');
   /* if (storeCompareProductButtons) {
        storeCompareProductButtons.forEach((item) => {
            item.addEventListener('click', () => {
                const csrfToken = document.head.querySelector("[name~=csrf-token][content]").content;
                let productId = item.getAttribute('data-product-id');
                fetch('/compare/' + productId, {
                    headers: {
                        "Accept": "application/json",
                        "X-CSRF-Token": csrfToken
                    },
                    'method': 'POST'
                }).then((response) => {
                    let data = response.json();
                    if (response.status === 200) {

                    } else if (response.status === 500) {
                        alert(response.statusText);
                    } else {

                    }
                })

            })
        })
    }

    if (destroyCompareProductButtons) {
        destroyCompareProductButtons.forEach((item) => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                const csrfToken = document.head.querySelector("[name~=csrf-token][content]").content;
                let productId = item.getAttribute('data-product-id');
                fetch('/compare/' + productId, {
                    headers: {
                        "Accept": "application/json",
                        "X-CSRF-Token": csrfToken
                    },
                    'method': 'DELETE'
                }).then((response) => {
                    let data = response.json();
                    if (response.status === 200) {
                        location.reload();
                    } else if (response.status === 500) {
                        alert(response.statusText);
                    } else {

                    }
                })
            })
        })
    }*/
});

function setHeightOfCompareProducts() {
    let heightOfProductHeader = 0;
    let leftBox = document.querySelector('.compare__leftBoxParameters');
    let compareItems = document.querySelectorAll('.compare-item');

    compareItems.forEach((item) => {
        item.querySelector('.compare__product-wrapper').style.height = "auto";
        let height = item.querySelector('.compare__product-wrapper').offsetHeight;
        console.log(height);
        if (height > heightOfProductHeader) {
            heightOfProductHeader = height;
        }
    });

    leftBox.style.marginTop = heightOfProductHeader + "px";
    compareItems.forEach((item) => {
        item.querySelector('.compare__product-wrapper').style.height = heightOfProductHeader + "px";
    });
}
